// PA Audit: the routes and the sidebar rows of `wealth.pa-dealing.audit` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.pa-dealing.audit',
    routes: [
        {
            frontend: 'comply',
            path: 'pa-audit',
            lazy: () => import('@/pages/comply/pa-audit/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'pa-audit',
            label: 'PA Audit',
            href: '/comply/pa-audit',
            icon: 'ScrollText',
            group: 'pa-dealing',
            order: 540,
        },
    ],
});
